import { Routes, Route } from "react-router-dom";
import { PageLayout } from "./components/PageLayout";
import { RegistraDenuncia } from "./pages/CAFAMRegistraDenuncia";
import {IncioSICOF} from './pages/CAFAMHome'
import {TipoConductaCAFAM} from './pages/CAFAMTipoConducta'
import {CheckPopUp} from './components/DataContext';
import './App.css';

const Pages = () => {
  return (
    <CheckPopUp> 
      <Routes>
          <Route exact path='/' element={<IncioSICOF/>} />
          <Route path="/TipoConducta" element={<TipoConductaCAFAM/>} />
          <Route exact path='/RegistrarDenuncia' element={<RegistraDenuncia/>} />
      </Routes>
    </CheckPopUp>
  );
};

const App = () => {
  return (
      <PageLayout>
          <Pages />
      </PageLayout>
  );
};

export default App;
